var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"In Queue","active":""}},[_c('scan-queue')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Scanning"}},[_c('scan-scanning')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Scanned Tags"}},[_c('scan-completed')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41382010","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/demand/pages/ScanTabs.vue
// module id = null
// module chunks = 